
export const SELECTION_TYPE_USER = 'user';
export const SELECTION_TYPE_DEFAULT = 'default';
export const SELECTION_TYPE_AUTOMATIC = 'automatic';
